export default __webpack_public_path__ + "static/media/flyback_controller_dc_ssr_neg.15ac9b27.svg";